






















import { defineComponent, ref, watch, onMounted } from "@vue/composition-api";
import { Message } from "element-ui";
import { GraphicInfo } from "@tuliu/base-map";
import { getLngLatToAddress } from "@/api/njfw";
import { LatLngTuple } from "@tuliu/leaflet";
import { useAppStore, AREAINFO } from "@/store/app";
import { bus } from "@/utils/bus";
import DrawBase from "@/components/DrawBase.vue";
import MapSearch from "@/components/MapSearch.vue";

export default defineComponent({
  components: {
    DrawBase,
    MapSearch,
  },
  emits: ["handleAnalysisLoc"],
  setup(_, { emit }) {
    const appStore = useAppStore();

    const ghList = ref<GraphicInfo[]>([]);
    const address = ref<string>("");
    const locId = ref<string>("");
    const locName = ref<string>("");
    const locationRef = ref<typeof DrawBase | null>(null);
    const center = ref<LatLngTuple>(AREAINFO[appStore.locId].center);
    const mapZoom = ref<number>(10);

    const handleUpdateMapCenter = (newMapCenter: LatLngTuple) => {
      center.value = newMapCenter;
    };
    const getAddressInfo = async () => {
      const params = {
        lng: center.value[1],
        lat: center.value[0],
      };
      const [err, data] = await getLngLatToAddress(params);

      if (!err && data !== undefined) {
        if (!data.address) {
          Message({ type: "warning", message: "该区域地址不存在！" });
          return;
        }
        address.value = data.address;
        locId.value = data.locInfo.town.id;
        locName.value = `${data.locInfo.province.name}-${data.locInfo.city.name}-${data.locInfo.county.name}-${data.locInfo.town.name}`;

        const analysisLoc = {
          latLng: ghList.value[0].path[0].join(),
          address: address.value,
          locId: locId.value,
          locName: locName.value,
        };
        emit("handleAnalysisLoc", analysisLoc);
      }
    };

    onMounted(() => {
      // 绘制圈选边界
      (locationRef.value as any).geoJSON(AREAINFO[appStore.locId].boundary);

      ghList.value = [
        {
          id: ghList.value.length,
          titleClassName: "click-point",
          title: `<div class="click-point-title"></div>`,
          onlyShowTitle: true,
          isClosed: true,
          length: 0,
          area: 0,
          editorEnable: false,
          path: [center.value],
        },
      ];

      bus.$on("on-map-click-point", (point: LatLngTuple) => {
        center.value = point;

        ghList.value = [
          {
            id: ghList.value.length,
            titleClassName: "click-point",
            title: `<div class="click-point-title"></div>`,
            onlyShowTitle: true,
            isClosed: true,
            length: 0,
            area: 0,
            editorEnable: false,
            path: [point],
          },
        ];
      });
    });

    watch(
      () => center.value,
      () => {
        getAddressInfo();
      },
      { immediate: true }
    );

    return {
      locationRef,
      mapZoom,
      ghList,
      address,
      locName,
      center,
      handleUpdateMapCenter,
    };
  },
});
